<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <v-card color="orange" dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon size="48" class="me-4">mdi-account-group</v-icon>
              <div>
                <div class="text-h3 font-weight-bold">
                  {{ estadisticas?.clientes || 0 }}
                </div>
                <div class="text-subtitle-1">Clientes Activos</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="$router.push('/admin/clients')"
            >
              Gestionar Clientes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card color="blue" dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon size="48" class="me-4">mdi-file-document-multiple</v-icon>
              <div>
                <div class="text-h3 font-weight-bold">
                  {{ estadisticas?.documentos || 0 }}
                </div>
                <div class="text-subtitle-1">Documentos Subidos</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="$router.push('/admin/archivos')"
            >
              Gestionar Documentos
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card color="green" dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon size="48" class="me-4">mdi-briefcase</v-icon>
              <div>
                <div class="text-h3 font-weight-bold">
                  {{ estadisticas?.contactanos || 0 }}
                </div>
                <div class="text-subtitle-1">Contactanos</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="$router.push('/admin/contactos')"
            >
              Gestionar Contactanos
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" md="4">
        <v-card color="brown" dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon size="48" class="me-4">mdi-account-details</v-icon>
              <div>
                <div class="text-h3 font-weight-bold">
                  {{ estadisticas?.consultorias || 0 }}
                </div>
                <div class="text-subtitle-1">Consultorias</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="$router.push('/admin/consultorias')"
            >
              Gestionar Consultorias
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card color="yellow" dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon size="48" class="me-4">mdi-newspaper</v-icon>
              <div>
                <div class="text-h3 font-weight-bold">
                  {{ estadisticas?.noticias || 0 }}
                </div>
                <div class="text-subtitle-1">Noticias</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="$router.push('/admin/noticias')"
            >
              Gestionar Noticias
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card color="indigo" dark>
          <v-card-text>
            <div class="d-flex align-center">
              <v-icon size="48" class="me-4">
                mdi-account-key
              </v-icon>
              <div>
                <div class="text-h3 font-weight-bold">
                  {{ estadisticas?.admins || 0 }}
                </div>
                <div class="text-subtitle-1">Administradores</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="$router.push('/admin/administrador')"
            >
              Gestionar Administradores
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue"
import { useStore } from "vuex"

const store = useStore()
const estadisticas = computed(() => store.getters["estadisticas/getEstadisticas"])
const loading = computed(() => store.getters["estadisticas/isLoading"])

onMounted(() => {
  store.dispatch("estadisticas/fetchEstadisticas")
})
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>